import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { getAuthToken } from '../services/api';

function PrivateRoute({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(null);

  useEffect(() => {
    const token = getAuthToken();
    setIsAuthenticated(!!token);
  }, []);

  if (isAuthenticated === null) {
    return <div style={{ textAlign: 'center', padding: '50px' }}>טוען...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

export default PrivateRoute;
